module.exports = __webpack_public_path__ + "static/media/link.bce9d83c.svg";